import React from 'react'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
import OrderContainer from '../containers/Order/orderContainer'
import ShowOrderContainer from '../containers/Order/showOrderContainer'
import EditOrderContainer from '../containers/Order/editOrderContainer'

const Order = ({ match }) => (
  <Switch>
    <Route exact path={`${match.path}`} component={OrderContainer} />
    <Route exact path={`${match.path}/all`} render={(props) => <OrderContainer {...props} presetScope="all" />} />
    <Route exact path={`${match.path}/fulfilled`} render={(props) => <OrderContainer {...props} presetScope="fulfilled" />} />
    <Route exact path={`${match.path}/unfulfilled`} render={(props) => <OrderContainer {...props} presetScope="unfulfilled" />} />
    <Route exact path={`${match.path}/paid`} render={(props) => <OrderContainer {...props} presetScope="paid" />} />
    <Route exact path={`${match.path}/unpaid`} render={(props) => <OrderContainer {...props} presetScope="unpaid" />} />
    <Route path={`${match.path}/:id/edit`} component={EditOrderContainer} />
    <Route path={`${match.path}/:id`} component={ShowOrderContainer} />
  </Switch>
)

Order.propTypes = {  
  match: PropTypes.object,
}

export default Order
